module.exports = __webpack_public_path__ + "img/RegCat-assistant.3c154ab5.svg";